export default {
  tags_import_title: 'Importar Etiquetas',
  tags_import_button: 'Importar',
  tags_import_cancel: 'Cancelar',
  tags_comma: 'Coma (,)',
  tags_semicolon: 'Punto y coma (;)',
  tags_selectDelimiter: 'Seleccionar',
  tags_delimiter: 'Delimitador',
  tags_error_delimiter: 'El delimitador es requerido',
  tags_error_file_required: 'El archivo es requerido',
  tags_import_description: 'Sube un archivo CSV o Excel para importar etiquetas. Asegúrate de que el archivo incluya las columnas requeridas y siga el formato esperado.',
  tags_import_file_label: 'Seleccionar archivo a importar',
  tags_import_success: 'La importación de etiquetas se inició exitosamente. Recibirás una notificación cuando el proceso esté completo.',
  tags_import_success_title: 'Importación Iniciada',
  tags_import_error_title: 'Error de Importación',
  tags_import_instructions: 'Nota Importante: La columna ID es obligatoria. Si el proceso de importación está destinado a actualizar registros existentes, realiza una exportación de la tabla sin editar el valor de la columna ID para mantener la referencia del registro. Si deseas crear nuevas etiquetas, deja la columna ID en blanco.',
  tags_download_template: 'Descargar plantilla',
  tags_template_labelColumn: 'Etiqueta',
  tags_template_colorColumn: 'Color (Formato Hex)',
  tags_template_parentlabel: 'Etiqueta Padre',

  tags_import_error_CT01: 'Archivo CSV vacío: El archivo no contiene filas de datos. Por favor, añade al menos una fila con información de etiquetas.',
  tags_import_error_CT02: 'Error en el formato CSV - La columna ID y la columna Etiqueta son requeridas para las actualizaciones de etiquetas.',
  tags_import_error_CT03: 'No se encontraron filas de datos válidas: La etiqueta no puede estar vacía en todas las filas.',
};